import React from 'react'
import { Controller, useFormContext } from 'react-hook-form';
import { Autocomplete, Checkbox, TextField } from '@mui/material';
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const RFHAutocomplete = React.memo(({ options = [], isCheckbox = false, multiple = false, label="User", name = "user_id", ...props }) => {
    const { control } = useFormContext();
    
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <Autocomplete
                    {...field}
                    multiple={multiple}
                    options={options}
                    getOptionLabel={(option) => option?.label || ""}
                    onChange={(_, value) => {
                        if (multiple) {
                            const selectedValues = value.map(option => option?.value || "");
                            field.onChange(selectedValues);
                        } else {
                            field.onChange(value?.value || "");
                        }
                    }}
                    value={
                        multiple
                            ? options.filter(option => 
                                Array.isArray(field.value) && field.value.length > 0
                                    ? field.value.includes(option.value)
                                    : false
                              )
                            : options.find(option => option?.value === field?.value) || null
                    }
                    renderOption={
                        isCheckbox
                            ? (props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li
                                        key={`${option.value}`}
                                        {...optionProps}
                                    >
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.label}
                                    </li>
                                );
                            }
                            : (props, option) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={option.value} {...optionProps}>
                                        {option.label}
                                    </li>
                                );
                            }
                    }
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={label}
                            required
                            error={!!error}
                            helperText={error ? error?.message : ""}
                        />
                    )}
                    {...props}
                />
            )}
        />
    )
});

